// 分享到朋友圈，只有分享白名单内的页面可以正常分享，其余页面改为分享首页
const shareWhiteList = [
	'pages/index/index', // 首页
	'pages/merchant/merchant', // 附近商家
	'pages/shop/shop', // 在线商城
	'pages/merchantDetail/merchantDetail', // 商家详情
	'pages/goodsDetail/goodsDetail', // 在线商城商品详情页
]
export function onShareAppMessage() {
	let userInfo = uni.getStorageSync('userInfo');
	// console.log('userInfo', userInfo)
	if (userInfo) {
		userInfo = JSON.parse(userInfo);
	}

	// 获取当前页面栈信息
	const pages = getCurrentPages();
	const currentPage = pages[pages.length - 1];
	const currentRoute = currentPage.route;

	// 构建基础路径
	let path = '/' + currentRoute;

	// 获取当前页面的 options（即查询参数）
	const options = currentPage.options || {};

	// 移除原来的 fid 参数
	const filteredOptions = Object.keys(options)
		.filter(key => key !== 'fid') // 过滤掉 fid 参数
		.reduce((acc, key) => {
			acc[key] = options[key];
			return acc;
		}, {});

	// 将过滤后的查询参数转换为字符串形式
	const queryString = Object.keys(filteredOptions)
		.map(key => `${encodeURIComponent(key)}=${encodeURIComponent(filteredOptions[key])}`)
		.join('&');

	// 添加新的 fid 参数
	const fidParam = `fid=${userInfo ? userInfo.user_id : ''}`;

	// 组合最终的路径
	if (queryString) {
		path += '?' + queryString + '&' + fidParam;
	} else {
		path += '?' + fidParam;
	}

	//console.log('分享链接', path);
	// 如果path是商品详情，取商品名称+价格
	let pageTitle = '赞赏业态';
	let imageUrl = '';
	console.log('currentPage.route', currentPage.route)
	// 判断是否是店铺首页
	if (currentPage.route == 'pages/goodsDetail/goodsDetail') {
		imageUrl = currentPage.data.banner_list[0];
		let goodsName = currentPage.data.goods_name;

		let goods_price_min = currentPage.data.goods_price_min;
		goods_price_min = "💰" + goods_price_min*1;		

		let goods_xf_price_min = currentPage.data.goods_xf_price_min;
		if (goods_xf_price_min > 0) {
			goods_xf_price_min = '+' + goods_xf_price_min*1 + '金'
		}else{
			goods_xf_price_min = '';
		}

		pageTitle = goods_price_min + goods_xf_price_min + ' 🉐' + goodsName;
	} else if (currentPage.route == 'pages/merchantDetail/merchantDetail') {
		pageTitle = currentPage.data.detailRow.name
		imageUrl = currentPage.data.detailRow.avatar
	} else if (currentPage.route == 'pages/articleDetail/articleDetail') {
		pageTitle = currentPage.data.formData.title || '赞赏业态'
		imageUrl = currentPage.data.formData.cover_img || ''
	}

	let shareInfo = {
		title: pageTitle,
		path: path,
		imageUrl: imageUrl // 分享卡片的图片，可选
	};
	
	// console.log(currentPage);
	// console.log('onShareAppMessage shareInfo', shareInfo)
	return shareInfo;
}

// 不用这个方法，朋友圈分享使用common.js的onShareTimeline方法
export function onShareTimeline () {
	let userInfo = uni.getStorageSync('userInfo');
	if (userInfo) {
		userInfo = JSON.parse(userInfo);
	}
	// 获取当前页面栈信息
	const pages = getCurrentPages();
	const currentPage = pages[pages.length - 1];
	const currentRoute = currentPage.route;

	// 构建基础路径
	let path = '/' + currentRoute;

	// 获取当前页面的 options（即查询参数）
	const options = currentPage.options || {};

	// 移除原来的 fid 参数
	const filteredOptions = Object.keys(options)
		.filter(key => key !== 'fid') // 过滤掉 fid 参数
		.reduce((acc, key) => {
			acc[key] = options[key];
			return acc;
		}, {});

	// 将过滤后的查询参数转换为字符串形式
	const queryString = Object.keys(filteredOptions)
		.map(key => `${encodeURIComponent(key)}=${encodeURIComponent(filteredOptions[key])}`)
		.join('&');

	// 添加新的 fid 参数
	const fidParam = `fid=${userInfo ? userInfo.user_id : ''}`;

	// 组合最终的路径
	if (queryString) {
		path += '?' + queryString + '&' + fidParam;
	} else {
		path += '?' + fidParam;
	}
	console.log('path', path)
	//console.log('分享链接', path);
	// 如果path是商品详情，取商品名称+价格
	let pageTitle = '赞赏业态，支付共享商家收益';
	let imageUrl = '';
	// 判断是否是店铺首页
	if (currentPage.route == 'pages/goodsDetail/goodsDetail') {
		imageUrl = currentPage.data.banner_list[0];
		let goodsName = currentPage.data.goods_name;

		let goods_price_min = currentPage.data.goods_price_min;
		goods_price_min = "💰" + goods_price_min*1;		

		let goods_xf_price_min = currentPage.data.goods_xf_price_min;
		if (goods_xf_price_min > 0) {
			goods_xf_price_min = '+' + goods_xf_price_min*1 + '金'
		}else{
			goods_xf_price_min = '';
		}

		pageTitle = goods_price_min + goods_xf_price_min + ' 🉐' + goodsName;
	} else if (currentPage.route == 'pages/merchantDetail/merchantDetail') {
		console.log('currentPage', currentPage)
		pageTitle = currentPage.data.detailRow.name
		imageUrl = currentPage.data.detailRow.avatar
	}

	let shareInfo = {
		title: pageTitle,
		query: queryString ? `${queryString}&${fidParam}` : `${fidParam}`,
		imageUrl: imageUrl // 分享卡片的图片，可选
	};
	// console.log('shareInfo', shareInfo)
	return shareInfo

}